export const styles = {
  container: {
    mainContainer: "flex flex-col",
    outletContainer: "w-full h-full justify-center items-center flex flex-col",
  }
};